import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../contents/pricing/Layout';
import SEO from '../components/seo';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEO title="Pricing" mdxType="SEO" />
    <h1>{`Pricing`}</h1>
    <h2>{`Free`}</h2>
    <ul>
      <li parentName="ul">{`Unlimited diagrams`}</li>
      <li parentName="ul">{`API integration`}</li>
      <li parentName="ul">{`1 seat`}</li>
      <li parentName="ul">{`Limited diagram size`}</li>
      <li parentName="ul">{`Watermark`}</li>
    </ul>
    <a className="button primary" rel="nofollow" href="https://nicolaskeller.typeform.com/to/HsLUBb" onClick={() => ga('send', 'event', 'Pricing', 'free')}>
  Choose
    </a>
    <h2>{`Startup `}<strong parentName="h2">{`$14`}</strong>{` `}<em parentName="h2">{`/mo`}</em></h2>
    <ul>
      <li parentName="ul">{`Unlimited diagrams`}</li>
      <li parentName="ul">{`API integration`}</li>
      <li parentName="ul">{`5 seats`}</li>
      <li parentName="ul">{`Unlimited diagram size`}</li>
      <li parentName="ul">{`Editable diagrams`}</li>
      <li parentName="ul">{`No watermark`}</li>
      <li parentName="ul">{`Support`}</li>
    </ul>
    <a className="button" rel="nofollow" href="https://nicolaskeller.typeform.com/to/HsLUBb" onClick={() => ga('send', 'event', 'Pricing', 'startup')}>
  Choose
    </a>
    <h2>{`Enterprise `}<strong parentName="h2">{`$49`}</strong>{` `}<em parentName="h2">{`/mo`}</em></h2>
    <ul>
      <li parentName="ul">{`Unlimited diagrams`}</li>
      <li parentName="ul">{`API integration`}</li>
      <li parentName="ul">{`20 seats`}</li>
      <li parentName="ul">{`Unlimited diagram size`}</li>
      <li parentName="ul">{`Editable diagrams`}</li>
      <li parentName="ul">{`No watermark`}</li>
      <li parentName="ul">{`Priority support`}</li>
      <li parentName="ul">{`Diagrams from GitHub files`}</li>
    </ul>
    <a className="button primary" rel="nofollow" href="https://nicolaskeller.typeform.com/to/HsLUBb" onClick={() => ga('send', 'event', 'Pricing', 'enterprise')}>
  Choose
    </a>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      